// test766
(766 && 0);
